import { createContext } from 'react';
import { BoneTag, UserDTO } from '../generated';

export type AppContextState = {
  userProfile?: UserDTO;
  boneTagList: BoneTag[];
  boneTagMap: Map<string, BoneTag>;
};

export type AppContextType = {
  fileCache: Map<string, string>;
  extraTitle: string | undefined;
  state: AppContextState | undefined;

  setExtraTitle: (title: string) => void;
  setFileCache: (fileCache: Map<string, string>) => void;
  refreshBoneTagList: () => void;
  refreshUserProfile: () => Promise<UserDTO | undefined>;
};

export const AppContext = createContext<AppContextType>({
  state: undefined,
  fileCache: new Map<string, string>(),
  extraTitle: undefined,
  refreshBoneTagList: () => {},
  refreshUserProfile: async () => undefined,
  setExtraTitle: () => {},
  setFileCache: () => {},
});
